/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import {
  AbstractRestService,
  arrayOf, Enum,
  identity,
  RestSettings,
  SlicedDataSource,
} from '@gh/core-data';
import {
  JobListItemDto,
  JobListItemMapper,
  CMJobListFilterDto,
  JobCMListFilterMapper,
  JobBillingWorksheetMapper,
  JobBillingWorksheet,
  JobBillingWorksheetItem,
  JobBillingWorksheetExportMapper,
  JobBillingWorksheetFilterMapper,
} from '@gh/builder-shared-data';
import { Observable } from 'rxjs';
import { map$ } from '@gh/rx/operators';
import { GridColumn } from '@gh/core-ui-grid';
import { ID } from '@gh/common-shared-data';

export type WorkSheetFilter = {
  dateFrom: Date;
  dateTo: Date;
  dateType: any;
  filterType: string;
  isSlabExist: boolean;
  masterZoneId: ID;
  officeId: ID;
  searchString: string;
  showActive: boolean;
  showDpp: boolean;
  showFinalized: boolean;
  showNotProceeding: boolean;
};

@Injectable()
export class CMJobRestService extends AbstractRestService {
  constructor(
    private settings: RestSettings,
    ) {
    super(settings);
  }

  findAllCmAsDataSource(filter: CMJobListFilterDto): SlicedDataSource<JobListItemDto> {
    return this.createSlicedDataSourceGet(
      `${this.jad}/jobs-contract-manager`,
      filter, JobCMListFilterMapper, arrayOf(JobListItemMapper),
    );
  }

  getBillingWorksheet(filter: WorkSheetFilter): Observable<JobBillingWorksheet> {
    return this.httpGet(
      `${this.jad}/jobs-contract-manager/billing-worksheet`,
      filter,
      JobBillingWorksheetFilterMapper,
      arrayOf(JobBillingWorksheetMapper),
    ).pipe(map$((res) => (
      { items: res }
    )));
  }

  saveBillingWorksheet(items: JobBillingWorksheetItem[]): Observable<JobBillingWorksheet> {
    return this.httpPut(
      `${this.jad}/jobs-contract-manager/billing-worksheet`,
      items,
      arrayOf(JobBillingWorksheetMapper),
      arrayOf(JobBillingWorksheetMapper),
    ).pipe(map$((res) => (
      { items: res }
    )));
  }

  exportBillingWorksheet(items: JobBillingWorksheetItem[], columns: GridColumn[]): Observable<{ url: string; fileName: string }> {
    return this.httpPost(
      `${this.jad}/jobs-contract-manager/billing-worksheet/export`,
      { gridLayout: { columns }, jobList: items },
      JobBillingWorksheetExportMapper,
      identity(),
    );
  }
}
